import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface TradePageWrapperProps {
  minHeight?: boolean;
  maxHeight?: boolean;
  className?: string;
  children?: ReactNode;
}

/** Wrapper that sets the height for the left and right sides of the Trade Page. */
export const TradePageWrapper: FC<TradePageWrapperProps> = ({
  minHeight = true,
  maxHeight = true,
  className,
  children,
}) => (
  <div
    className={twMerge(
      // Heights set to match Orderbook height at each breakpoint
      minHeight
        ? 'min-h-[550px] lg:min-h-[618px] 2xl:min-h-[628px] min-[1640px]:min-h-[680px] 3xl:min-h-[804px] 4xl:min-h-[828px] 5xl:min-h-[894px]'
        : '',
      maxHeight
        ? 'min-h-[550px] lg:max-h-[618px] 2xl:max-h-[628px] min-[1640px]:max-h-[680px] 3xl:max-h-[804px] 4xl:min-h-[828px] 5xl:max-h-[894px]'
        : '',
      className
    )}
  >
    {children}
  </div>
);
